import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  alpha,
  Zoom,
} from '@mui/material';
import {
  Warning,
  Delete,
  Info,
  CheckCircle,
  Error,
  Help,
} from '@mui/icons-material';

const iconMap = {
  warning: { icon: Warning, color: 'warning' },
  delete: { icon: Delete, color: 'error' },
  danger: { icon: Error, color: 'error' },
  info: { icon: Info, color: 'info' },
  success: { icon: CheckCircle, color: 'success' },
  question: { icon: Help, color: 'primary' },
};

const ConfirmDialog = ({
  open,
  title = 'Confirmar',
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  onConfirm,
  onCancel,
  confirmColor = 'error',
  type = 'warning',
  loading = false,
  icon: customIcon,
  children,
}) => {
  const iconConfig = iconMap[type] || iconMap.warning;
  const IconComponent = customIcon || iconConfig.icon;
  const iconColor = iconConfig.color;

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
      TransitionComponent={Zoom}
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: 3,
        },
      }}
    >
      <DialogTitle sx={{ pb: 1, pt: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          <Box
            sx={{
              p: 2,
              borderRadius: '50%',
              backgroundColor: (theme) => alpha(theme.palette[iconColor].main, 0.12),
              color: `${iconColor}.main`,
              mb: 2,
            }}
          >
            <IconComponent sx={{ fontSize: 40 }} />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', pb: 1 }}>
        {message && (
          <Typography color="text.secondary" sx={{ lineHeight: 1.6 }}>
            {message}
          </Typography>
        )}
        {children}
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          py: 2.5,
          gap: 1.5,
          justifyContent: 'center',
        }}
      >
        <Button
          onClick={onCancel}
          disabled={loading}
          variant="outlined"
          sx={{
            flex: 1,
            maxWidth: 150,
            borderColor: 'grey.300',
            color: 'text.secondary',
            '&:hover': {
              borderColor: 'grey.400',
              backgroundColor: (theme) => alpha(theme.palette.grey[500], 0.08),
            },
          }}
        >
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color={confirmColor}
          disabled={loading}
          sx={{
            flex: 1,
            maxWidth: 150,
          }}
        >
          {loading ? 'Procesando...' : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
